import { getCurrentMonthMemberDashboard } from "../../http/renewalHttp/RenewalMemberHttp"
import { useCallback, useEffect, useState } from "react"
import { Stack, Pagination } from "@mui/material"
import { createPortal } from "react-dom"
import FormButton from "../FormButton"
import Input from "../Input"
import Div from "../Div"


export default function CurrentMonthMemberModal({ handleClicked, flags, ...props }) {

    const [domainList, setDomainList] = useState()
    const [initialDomainList, setInitialDomainList] = useState()

    const [search, setSearch] = useState('')

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 15;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = domainList ? domainList.slice(indexOfFirstItem, indexOfLastItem) : null;

    // Calculate total pages
    const totalPages = domainList ? Math.ceil(domainList.length / itemsPerPage) : null;

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const getCurrentRenewalDomain = useCallback(async () => {

        const response = await getCurrentMonthMemberDashboard(flags)
        console.log(response)
        setDomainList(response.domains)
        setInitialDomainList(response.domains)

    }, [flags])

    useEffect(() => {

        getCurrentRenewalDomain()

    }, [getCurrentRenewalDomain])

    function handleClose() {
        handleClicked(false);
    }

    function handleSearchCustomer(event) {

        const search_item = event.target.value;

        console.log(search_item)
        const filteredList = initialDomainList.filter((customer) => {

            if ((customer && customer.customerDomain)) {

                return customer.customerDomain.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        setDomainList(filteredList);
        setSearch(search_item)

    }

    return <>
        {
            createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', width: '90%', overflow: 'scroll' }}>

                        <Div className="form-group" style={{marginLeft:'15px'}}>
                            Domains Under {flags}
                        </Div>
                        <Div className='row'>

                        <Div className="toolbar-item col-sm-5" role="group" style={{marginLeft:'15px'}} >

                            <Input type='text' name='text' id='text' value={search}
                                onChange={handleSearchCustomer}
                            />

                        </Div>
                        </Div>

                        <Div className='col-md-12 margin_top'>
                            {domainList ?
                                <>
                                    <table className="table" border="1">
                                        <thead>
                                            <tr>
                                                <th>Customer Domain</th>
                                                <th>Plan</th>
                                                <th>Status</th>
                                                <th>License</th>
                                                <th>Users</th>
                                                <th>Sku Id</th>
                                                <th className="sortable-header"
                                                // onClick={() => handleSort("renewal_date")}
                                                >Renewal Date
                                                    {/* {sortColumn === "renewal_date" ? (
                                    sortOrder === "asc" ? (
                                        <FaSortUp className="sort-icon" />
                                    ) : (
                                        <FaSortDown className="sort-icon" />
                                    )
                                ) : (
                                    <FaSort className="sort-icon" /> // Default sort icon
                                )} */}
                                                </th>
                                                <th>Zone</th>
                                                <th>Google Renewal Date</th>
                                                <th>Price</th>
                                                <th>Segments</th>
                                                <th>Follow Up Comments</th>
                                                <th>Highlighted Case Flag</th>
                                                <th>Confirmation Status</th>
                                                <th>Aggrement Status</th>
                                                <th>Price Per User</th>
                                                <th>Special Comment</th>
                                                <th>Task Status</th>
                                                <th>Renewed License</th>
                                                <th>Extension Date</th>

                                                {/* <th></th> */}
                                            </tr>
                                        </thead>
                                        <tbody id="tableBody">
                                            {currentItems.map((customer) =>
                                                <>
                                                    <tr key={customer.renewal_id}>
                                                        <td>
                                                            {customer.customerDomain}
                                                        </td>
                                                        <td>{customer.plan}</td>
                                                        <td>{customer.status}</td>
                                                        <td>{customer.usedSeats}</td>
                                                        <td>{customer.maxSeats}</td>
                                                        <td>{customer.skuName}</td>
                                                        <td>{customer.shivaami_renewal_date}</td>
                                                        <td>{customer.zone}</td>
                                                        <td>{customer.Google_renewal_date}</td>
                                                        <td>{customer.price}</td>
                                                        <td>{customer.segments} </td>
                                                        <td></td>
                                                        <td>{customer.comments}</td>
                                                        <td>
                                                            {customer.agreement_status}
                                                        </td>
                                                        <td>{customer.price_per_user}</td>
                                                        <td>{customer.special_comments}</td>
                                                        <td>{customer.comment3 ? customer.comment3 : customer.comment2}</td>
                                                        <td>{customer.add_lic}</td>
                                                        <td>{customer.extension_date}</td>


                                                    </tr>
                                                </>
                                            
                                            )

                                            }
                                        </tbody>
                                    </table>
                                    {domainList.length > 0 ?
                                        <Stack spacing={2}>
                                            <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                                            </Pagination>

                                        </Stack> : null
                                    }
                                </>
                                : null}
                        </Div>
                        <Div className="form-group">
                            <Div className='row'>
                                <Div className='col-sm-9'>
                                </Div>
                                <Div className='col-sm-2'>
                                    <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                </Div>
                            </Div>

                        </Div>

                    </dialog>

                </Div>
                , document.getElementById('modal'))

        }
    </>
}